"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Facebook, Youtube, Linkedin, Instagram, ArrowUp, Music2, Loader } from "lucide-react";
const socialLinks = [{
  id: "facebook",
  icon: Facebook,
  href: "https://wa.me/526149800517",
  label: "Facebook"
}, {
  id: "instagram",
  icon: Instagram,
  href: "https://wa.me/526149800517",
  label: "Instagram"
}, {
  id: "youtube",
  icon: Youtube,
  href: "https://wa.me/526149800517",
  label: "YouTube"
}, {
  id: "linkedin",
  icon: Linkedin,
  href: "https://wa.me/526149800517",
  label: "LinkedIn"
}, {
  id: "tiktok",
  icon: Music2,
  href: "https://wa.me/526149800517",
  label: "TikTok"
}];
const corporateLinks = [{
  id: "about",
  label: "Acerca de nosotros",
  href: "/nosotros"
}, {
  id: "mission",
  label: "Misión y visión",
  href: "#"
}, {
  id: "ethics",
  label: "Código de ética",
  href: "#"
}, {
  id: "culture",
  label: "Cultura",
  href: "#"
}, {
  id: "jobs",
  label: "Bolsa de trabajo",
  href: "#"
}];
const certificationLogos = [{
  id: "gptw",
  src: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-5.41.04-p.m.png?v=cag9lf5zz1n",
  srcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-5.41.04-p.m.png?v=y4xyyz6lf6-wvc-srcset",
  sizes: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-5.41.04-p.m.png?v=ur5x4fhf8fb-wvc-sizes",
  alt: "Great Place to Work 2023"
}];
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="rounded-lg bg-white/10 p-4 border border-white/20">
        <p className="text-sm text-white font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <FormField control={control} name="email" rules={{
      required: "El correo electrónico es requerido",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Correo electrónico inválido"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <div className="flex flex-col gap-3">
                <Input type="email" placeholder="Tu correo electrónico" className="h-12 bg-white text-zinc-900 placeholder:text-zinc-400 border-none rounded-lg focus-visible:ring-accent" {...field} />
                <Button type="submit" disabled={isSubmitting} className="h-12 w-full bg-white hover:bg-zinc-100 text-zinc-600 font-medium rounded-lg shadow-md transition-all">
                  {isSubmitting ? <>
                      <Loader className="mr-2 size-4 animate-spin" />
                      Enviando...
                    </> : "Suscríbete"}
                </Button>
              </div>
            </FormControl>
            <FormMessage className="text-red-400 text-xs" />
          </FormItem>} />
      {submitError && <p className="text-red-400 text-xs">{submitError}</p>}
      <p className="text-[10px] text-zinc-400 leading-tight">
        Al suscribirse, usted está de acuerdo con nuestro Aviso de privacidad y proporciona su consentimiento para recibir actualizaciones de Kalisch Acero.
      </p>
    </Form>;
}
export default function IndustrialFooter() {
  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <section id="industrialfooter" className="relative bg-zinc-950 text-white overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat opacity-20 grayscale" style={{
      backgroundImage: 'url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/industrial_city_footer.png)'
    }} />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-zinc-950/80 to-zinc-950" />

      <div className="container relative z-10 mx-auto px-4 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="space-y-8">
            <div className="flex justify-center mb-4">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/nijnirjnriejerergerg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/nijnirjnriejerergerg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/nijnirjnriejerergerg.png-wvc-sizes" alt="Kalisch Acero logo" className="max-w-[150px] w-full h-auto" loading="lazy" />
            </div>
            <div className="flex items-center gap-4">
              {socialLinks.map((social, i) => <Link key={social.id} to={social.href} newTab aria-label={social.label} data-index={i} className="text-zinc-400 hover:text-white transition-colors">
                  <social.icon className="size-6" />
                </Link>)}
            </div>
          </div>

          {}
          <div>
            <h3 className="text-lg font-bold text-white mb-8">Empresa</h3>
            <ul className="space-y-4">
              {corporateLinks.map((link, i) => <li key={link.id} data-index={i}>
                  <Link to={link.href} className="text-sm text-zinc-400 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <div className="flex flex-wrap items-start gap-6">
              {certificationLogos.map((cert, i) => <img key={cert.id} data-index={i} src={cert.src} data-wvc-srcset={cert.srcset} data-wvc-sizes={cert.sizes} alt={cert.alt} className="h-20 w-auto object-contain" loading="lazy" />)}
            </div>
          </div>

          {}
          <div>
            <h3 className="text-lg font-bold text-white mb-8">Suscríbete a nuestras noticias</h3>
            <FormProvider formId="footer-newsletter-redesign" sectionName="IndustrialFooter" defaultValues={{
            email: ""
          }} submitText="Suscríbete" successMessage="¡Gracias por suscribirse!">
              <NewsletterForm />
            </FormProvider>
          </div>

        </div>
      </div>

      {}
      <div className="relative z-10 border-t border-white/10 bg-zinc-950/50 backdrop-blur-sm">
        <div className="container mx-auto px-4 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-xs text-zinc-500 uppercase tracking-wider">
            <p>© {new Date().getFullYear()} Todos los derechos reservados.</p>
            <div className="flex items-center gap-4">
              <Link to="#" className="hover:text-white transition-colors">Términos y Condiciones</Link>
              <span className="text-zinc-800">|</span>
              <Link to="#" className="hover:text-white transition-colors">Aviso de Privacidad</Link>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
        {showTopBtn && <Button onClick={scrollToTop} size="icon" variant="secondary" className="size-12 rounded-lg shadow-lg bg-zinc-800 hover:bg-zinc-700 text-zinc-200 border border-zinc-700 transition-all duration-300 animate-in fade-in slide-in-from-bottom-4" aria-label="Volver arriba">
            <ArrowUp className="size-5" />
          </Button>}
      </div>
    </section>;
}